import { Component } from '@theme/component';

/** Native GET form only. Never filters a loaded page of products in JavaScript. */
class FreyaPriceFilter extends Component {
  #abort;
  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    window.addEventListener('pageshow', () => this.#restore(), { signal: this.#abort.signal });
    this.#restore();
  }
  updatedCallback() { super.updatedCallback(); this.#restore(); }
  disconnectedCallback() { this.#abort?.abort(); super.disconnectedCallback(); }
  #restore() {
    const params = new URL(location.href).searchParams;
    for (const name of ['filter.v.price.gte', 'filter.v.price.lte', 'sort_by']) {
      const input = this.querySelector(`[name="${name}"]`);
      if (input && params.has(name)) input.value = params.get(name);
    }
    this.syncConstraints();
  }
  syncConstraints() {
    const low = this.querySelector('[name="filter.v.price.gte"]');
    const high = this.querySelector('[name="filter.v.price.lte"]');
    if (!low || !high) return;
    high.min = low.value && Number(low.value) >= 0 ? low.value : '0';
    if (high.value && Number(high.value) >= 0) low.max = high.value;
    else low.removeAttribute('max');
  }
}
if (!customElements.get('freya-price-filter')) customElements.define('freya-price-filter', FreyaPriceFilter);
